import React from "react";
import { useNavigate } from "react-router-dom";
import "../../css/NotFound.css";

const NotFound = () => {

    const navigate = useNavigate();

    return (
        <div className="notfound-container">
            <div className="notfound-content">
                <h1>404</h1>
                <h2>Página não encontrada</h2>
                <p>Ops! A página que você procura não existe.</p>

                <button
                    onClick={() => navigate("/homepage")}
                    className="notfound-button"
                >
                    Voltar à Homepage
                </button>
            </div>
        </div>
    );
};

export default NotFound;